import { NAME_SOUND_HOVER, useGameSounds, useTranslate } from '@educaplay/core';
import { ClueIcon } from '../../icons';
import classes from './DialogClueHeader.module.scss';
import clsx from 'clsx';

function DialogClueHeader(props) {

    const { requestedClues, currentClue, onClueClick } = props;
    const t = useTranslate();
    const gameSound = useGameSounds();   


    return (
        <div className={classes.headercontainer}>
            <div className={classes.msgcontainer}>
                <div className={classes.msg}>{t('specific.informationClue')} {currentClue?.id}</div>
            </div>
            <div className={classes.buttonscluecontainer}>
                {requestedClues.map(clue => {
                    return (
                        <button
                            key={clue.id}
                            type="button"
                            className={clsx(classes.buttonclue, {
                                [classes.activeButton]: currentClue?.id === clue.id
                            })}
                            onClick={() => onClueClick(clue)}
                            onMouseEnter={()=>{gameSound.play(NAME_SOUND_HOVER)}}
                        >
                            <ClueIcon />
                        </button>
                    )
                })
                }
            </div>
        </div>
    )
}

export default DialogClueHeader;    
